import axios from 'axios';
import Cookies from 'js-cookie';

import {
  V1_RECIPES,
  V1_IMPORT_RECIPES,
  V1_EXPORT_RECIPES,
  V1_GET_ITEM_DROPDOWN,
  GET_ITEM_VARIANT,
  GET_ITEM_INGREDIENT,
  DELETE_RECIPES_BY_ID,
  CREATE_RECIPES,
  UPDATE_RECIPES,
  UPDATE_RECIPES_ALL_OUTLET,
  CREATE_ALL_OUTLET_RECIPES,
  GET_RECIPE_BY_VARIANT_ID,
} from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function postRecipes(data, params) {
  return axios
    .post(V1_RECIPES, data, { withCredentials: true, params })
    .catch(reject);
}

export function getRecipes(params) {
  return axios.get(V1_RECIPES, { params, withCredentials: true }).catch(reject);
}

export function getExportRecipes(params) {
  return axios
    .get(V1_EXPORT_RECIPES, { params, withCredentials: true })
    .catch(reject);
}

export function postImportRecipe(params, data) {
  return axios.post(V1_IMPORT_RECIPES, data, { params }).catch(reject);
}

export function getItemDropdown() {
  return axios
    .get(V1_GET_ITEM_DROPDOWN, { withCredentials: true })
    .catch(reject);
}

export function getItemIngredient(params) {
  const { page, per_page, keyword } = params;
  return axios
    .get(GET_ITEM_INGREDIENT(page, per_page, keyword), {
      withCredentials: true,
    })
    .catch(reject);
}

export function getItemVariant(selectedItem) {
  return axios
    .get(GET_ITEM_VARIANT(selectedItem), { withCredentials: true })
    .catch(reject);
}

export function deleteRecipesById(id) {
  return axios
    .delete(DELETE_RECIPES_BY_ID(id), { withCredentials: true })
    .catch(reject);
}

export function createRecipes(data) {
  return axios
    .post(CREATE_RECIPES, data, { withCredentials: true })
    .catch(reject);
}

export function updateRecipes(id, data) {
  return axios
    .put(UPDATE_RECIPES(id), data, { withCredentials: true })
    .catch(reject);
}

export function updateRecipesAllOutlet(id, data) {
  return axios
    .put(UPDATE_RECIPES_ALL_OUTLET(id), data, { withCredentials: true })
    .catch(reject);
}

export function createRecipesAllOutlet(data) {
  return axios
    .post(CREATE_ALL_OUTLET_RECIPES, data, { withCredentials: true })
    .catch(reject);
}

export function getRecipesByVariantId(id) {
  return axios
    .get(GET_RECIPE_BY_VARIANT_ID(id), { withCredentials: true })
    .catch(reject);
}

export function getFtueFlagging(email) {
  const ftueFlag = Cookies.get('isFTUEImportRecipe');
  if (ftueFlag === undefined) {
    return true;
  }
  const listUser = JSON.parse(ftueFlag);
  return !listUser.includes(email);
}

export function setFalseFtueFlag(email) {
  const ftueFlag = Cookies.get('isFTUEImportRecipe');
  if (ftueFlag === undefined) {
    const newFTUEFlag = [email];
    Cookies.set('isFTUEImportRecipe', JSON.stringify(newFTUEFlag));
  } else {
    const listUser = JSON.parse(ftueFlag);
    listUser.push(email);
    Cookies.set('isFTUEImportRecipe', JSON.stringify(listUser));
  }
}
